import Vue from 'vue';
import vSelect from 'vue-select/src/components/Select.vue';

Vue.component('autocomplete', vSelect);


//////////////////
// WEBPACK FOOTER
// ./src/plugins/vue-autocomplete.js
// module id = ./src/plugins/vue-autocomplete.js
// module chunks = 34